import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class RecruiterGuard implements CanActivate {
  private readonly allowedRoles = new Set(['admin', 'recruiter']);

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const user = this.authService.getCurrentUser();
    if (!user) {
      return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
    }
    if (this.allowedRoles.has(user.role)) return true;
    return this.router.createUrlTree(['/assesments']);
  }
}
